import b_thesis from './images/b_thesis.png';
import flutter from './images/todoflutter.jpg';
import trotterImg from './images/trotter.png';
import yawmiImg from './images/yawmi.png';
import matchlitImg from './images/matchlit.png';
import sarcasmImg from './images/sarcasm.png';
import prisonersImg from './images/prisoners.png';


const projectsData = [
  {
    title: "Trotter",
    year: "2026",
    description: "Flat-priced pet-sitting software for dog walkers and sitters. Offline-first PWA with one-tap GPS check-ins that sync when connectivity returns, Stripe billing and invoicing, and a mobile client portal.",
    live: "https://trotter.pet",
    image: trotterImg
  },
  {
    title: "Yawmi: Daily Hadith",
    year: "2026",
    description: "A daily hadith companion. React Native (Expo) app for iOS and Android with a live web version.",
    live: "https://yawmi-hadith.vercel.app",
    image: yawmiImg
  },
  {
    title: "MatchLit",
    year: "2025 - present",
    description: "Two-sided marketplace connecting brands with creators. Concierge brokering, Stripe Connect escrow payments, role-based onboarding and LLM-powered features. Next.js, Supabase and Drizzle ORM.",
    live: "https://matchlit.ai",
    image: matchlitImg
  },
  {
    title: "The Language of Radicalization",
    year: "2024 - 2025",
    description: "Master's thesis: cross-ideological NLP analysis of extremist rhetoric, fine-tuning DeBERTa and DistilBERT over 1.2M+ social media records with affective scoring, MANOVA/ANOVA testing and SHAP interpretability.",
    code: "https://github.com/HasanOma/the-language-of-radicalization"
  },
  {
    title: "Sarcasm Detection",
    year: "2024",
    description: "NLP models trained to tell The Onion from real news. The live demo runs Logistic Regression, a BiLSTM and DistilBERT side by side, entirely in your browser.",
    live: "https://hasanoma.github.io/tdt13_sarcasm_detection_in_news_headlines/",
    code: "https://github.com/HasanOma/tdt13_sarcasm_detection_in_news_headlines",
    image: sarcasmImg
  },
  {
    title: "Prisoner's Dilemma Tournament",
    year: "2023",
    description: "Axelrod-style iterated prisoner's dilemma with nine classic strategies and a genetically evolved sigmoid player that beats them all. Run tournaments, watch duels or play against the machine in the browser.",
    live: "https://hasanoma.github.io/Prisoners_dilemma/",
    code: "https://github.com/HasanOma/Prisoners_dilemma",
    image: prisonersImg
  },
  {
    title: "Marine Traffic Portal",
    year: "2023",
    description: "Bachelor's thesis for Accenture: real-time marine telemetry (AIS) and radar tracking in the Trondheim fjord. Python, Django and PostgreSQL on Azure with a live React frontend.",
    image: b_thesis
  },
  {
    title: "Flutter Todo App",
    year: "2023",
    description: "Cross-platform todo app with a local SQLite database.",
    code: "https://github.com/HasanOma/IDATT2506-prosjekt/tree/main/project",
    image: flutter
  },
  {
    title: "Onion Routing Network",
    year: "2022",
    description: "Multi-node anonymity network built from scratch in Java. Custom TCP socket protocol, RSA handshake into AES payload encryption, node-failure handling and fault tolerance.",
    code: "https://github.com/HasanOma/nettverk_prosjekt_OnionRouting"
  },
  {
    title: "This Website",
    year: "2023",
    description: "The site you are looking at. React and Tailwind CSS, hosted on GitHub Pages at hasanro.no.",
    code: "https://github.com/HasanOma/my-portfolio"
  }
];

export default projectsData;
